// Valais Conversion Boost — interactie (nav mega menu, PDP, sticky bar).
(function () {
  /* ---------- header: mega menu ---------- */
  var nav = document.querySelector('.vcb-nav');
  if (nav) {
    var items = Array.prototype.slice.call(nav.querySelectorAll('.vcb-nav__item--mega'));
    var closeTimer = null;

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        item.querySelector('.vcb-nav__link').setAttribute('aria-expanded', 'false');
      });
    }
    function open(item) {
      clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      item.querySelector('.vcb-nav__link').setAttribute('aria-expanded', 'true');
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeAll(); }, 120);
    }

    items.forEach(function (item) {
      item.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') open(item); });
      item.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') scheduleClose(); });
      item.addEventListener('focusin', function () { open(item); });
      item.addEventListener('focusout', function (e) {
        if (!(e.relatedTarget instanceof Node) || !item.contains(e.relatedTarget)) closeAll();
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('pointerdown', function (e) {
      if (!(e.target instanceof Element) || !e.target.closest('.vcb-nav')) closeAll();
    });

    // mobiel menu
    var burger = document.querySelector('[data-vcb-burger]');
    var mobile = document.querySelector('.vcb-mobilemenu');
    if (burger && mobile) {
      burger.addEventListener('click', function () {
        var openNow = mobile.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', String(openNow));
        burger.querySelector('[data-icon-menu]').style.display = openNow ? 'none' : '';
        burger.querySelector('[data-icon-x]').style.display = openNow ? '' : 'none';
      });
    }
  }

  /* ---------- qty steppers (PDP + sticky bar, gesynct) ---------- */
  function allQtyInputs() { return document.querySelectorAll('[data-vcb-qty-input]'); }
  document.addEventListener('click', function (e) {
    var btn = e.target instanceof Element && e.target.closest('[data-vcb-qty]');
    if (!btn) return;
    var delta = btn.getAttribute('data-vcb-qty') === 'up' ? 1 : -1;
    var value = 1;
    allQtyInputs().forEach(function (inp) { value = Math.max(1, (parseInt(inp.value, 10) || 1)); });
    value = Math.max(1, value + delta);
    allQtyInputs().forEach(function (inp) { inp.value = value; });
  });

  /* ---------- PDP: gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target instanceof Element && e.target.closest('[data-vcb-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-vcb-mainimg]');
    var img = thumb.querySelector('img');
    if (main && img) {
      main.src = img.getAttribute('data-full') || img.src;
      main.srcset = '';
    }
    document.querySelectorAll('[data-vcb-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- PDP: add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-vcb-atc')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-vcb-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        document.dispatchEvent(new CustomEvent('vcb:cart:added'));
        // Geen drawer aanwezig (of app-drawer actief)? Dan korte bevestiging op de knop.
        if (btn && !document.querySelector('[data-vcb-drawer]')) {
          var orig = btn.innerHTML;
          btn.innerHTML = '✓ Toegevoegd';
          setTimeout(function () { btn.innerHTML = orig; }, 1600);
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        window.location.href = '/cart';
      });
  });

  /* ---------- Google-reviewscore live bijwerken (optioneel) ---------- */
  function paintReviews(score, count) {
    var s = String(score).replace('.', ',');
    document.querySelectorAll('[data-vcb-review-score]').forEach(function (el) { el.textContent = String(score); });
    document.querySelectorAll('[data-vcb-review-line]').forEach(function (el) { el.textContent = '★ ' + s + ' Google Reviews'; });
    document.querySelectorAll('[data-vcb-review-usp]').forEach(function (el) { el.textContent = s + ' ★ Google'; });
    document.querySelectorAll('[data-vcb-review-count]').forEach(function (el) { el.textContent = count + ' reviews'; });
    document.querySelectorAll('[data-vcb-review-sub]').forEach(function (el) { el.textContent = 'op basis van ' + count + ' Google Reviews'; });
    document.querySelectorAll('[data-vcb-review-sub-pdp]').forEach(function (el) { el.textContent = 'Op basis van ' + count + ' Google Reviews'; });
  }

  // Echte review-teksten renderen (veilig: textContent, nooit innerHTML)
  function paintReviewCards(reviews) {
    var grid = document.querySelector('[data-vcb-google-reviews][data-vcb-live]');
    if (!grid || !reviews || !reviews.length) return;
    var frag = document.createDocumentFragment();
    reviews.slice(0, 3).forEach(function (rv) {
      var text = (rv.originalText && rv.originalText.text) || (rv.text && rv.text.text) || '';
      if (!text) return;
      var card = document.createElement('div');
      card.className = 'vcb-review';

      var stars = document.createElement('div');
      stars.className = 'vcb-review__stars';
      stars.textContent = '★★★★★'.slice(0, Math.round(rv.rating || 5));
      card.appendChild(stars);

      var quote = document.createElement('p');
      quote.className = 'vcb-review__quote';
      quote.textContent = '\u201C' + (text.length > 260 ? text.slice(0, 257) + '…' : text) + '\u201D';
      card.appendChild(quote);

      var author = document.createElement('span');
      author.className = 'vcb-review__author';
      var naam = (rv.authorAttribution && rv.authorAttribution.displayName) || 'Google-review';
      author.textContent = '— ' + naam;
      card.appendChild(author);

      frag.appendChild(card);
    });
    if (frag.childNodes.length) {
      grid.textContent = '';
      grid.appendChild(frag);
      grid.setAttribute('data-vcb-source', 'google');
    }
  }

  var cfg = window.VCB_REVIEWS || {};
  if (cfg.placeId && cfg.key) {
    var CACHE_KEY = 'vcb_google_reviews';
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.t < 864e5) {
        paintReviews(cached.score, cached.count);
        paintReviewCards(cached.reviews);
      }
    } catch (e) {}
    fetch('https://places.googleapis.com/v1/places/' + encodeURIComponent(cfg.placeId) +
          '?fields=rating,userRatingCount,reviews&languageCode=nl&key=' + encodeURIComponent(cfg.key))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.rating) return;
        var score = Number(data.rating).toFixed(1);
        var count = data.userRatingCount || cfg.count;
        paintReviews(score, count);
        paintReviewCards(data.reviews);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ score: score, count: count, reviews: data.reviews || [], t: Date.now() }));
        } catch (e) {}
      })
      .catch(function () {});
  }

  /* ---------- collectie: filters open op desktop, dicht op mobiel ---------- */
  var filtersDd = document.querySelector('[data-vcb-filters]');
  if (filtersDd && window.matchMedia('(min-width: 1024px)').matches) {
    filtersDd.open = true;
  }


  /* ---------- Winkelmand: slide-in drawer ---------- */
  var drawer = document.querySelector('[data-vcb-drawer]');
  if (drawer) {
    var itemsEl = drawer.querySelector('[data-vcb-drawer-items]');
    var emptyEl = drawer.querySelector('[data-vcb-drawer-empty]');
    var footEl = drawer.querySelector('[data-vcb-drawer-foot]');
    var totalEl = drawer.querySelector('[data-vcb-drawer-total]');
    var countEl = drawer.querySelector('[data-vcb-drawer-count]');
    var shipWrap = drawer.querySelector('[data-vcb-ship]');
    var shipText = drawer.querySelector('[data-vcb-ship-text]');
    var shipFill = drawer.querySelector('[data-vcb-ship-fill]');
    var wasEl = drawer.querySelector('[data-vcb-drawer-was]');
    var savingsEl = drawer.querySelector('[data-vcb-drawer-savings]');
    var savingsLabel = drawer.querySelector('[data-vcb-drawer-savings-label]');
    var savingsAmount = drawer.querySelector('[data-vcb-drawer-savings-amount]');

    function euro(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

    function openDrawer() {
      drawer.hidden = false;
      void drawer.offsetWidth; // forceer reflow zodat de transitie start (rAF vuurt niet in achtergrondtabs)
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('vcb-mand-open');
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      document.body.classList.remove('vcb-mand-open');
      setTimeout(function () { drawer.hidden = true; }, 250);
    }

    /* De verzendstaffel komt uit de winkelinstellingen en staat als getallen
       in de mand. Eerder haalden we het tarief op bij /cart/shipping_rates.json,
       maar dat endpoint rekent asynchroon en geeft ondertussen een lege lijst
       terug — dan stond er even niets, of het verkeerde bedrag. */
    function getal(el, naam, terugval) {
      var v = el ? parseInt(el.getAttribute(naam), 10) : NaN;
      return isNaN(v) ? terugval : v;
    }

    function staffelVan(el) {
      var s = {
        drempel: getal(el, 'data-threshold', 10000),
        tussenstap: getal(el, 'data-tussenstap', 0),
        laag: getal(el, 'data-tarief-laag', 0),
        hoog: getal(el, 'data-tarief-hoog', 0)
      };
      // Buiten Nederland en België kennen we het tarief niet; dan beloven we niets.
      s.bekend = s.laag > 0;
      if (s.tussenstap >= s.drempel) s.tussenstap = 0;
      return s;
    }

    function tariefBij(s, subtotaal) {
      if (subtotaal >= s.drempel) return 0;
      if (s.tussenstap > 0 && subtotaal >= s.tussenstap) return s.hoog;
      return s.laag;
    }

    /* Waar de klant nu naartoe werkt: eerst het lagere tarief, daarna gratis.
       Eén doel tegelijk — de hele staffel opsommen maakt de mand vol en de
       boodschap vaag. */
    function volgendeStap(s, subtotaal) {
      if (s.tussenstap > 0 && subtotaal < s.tussenstap) return { grens: s.tussenstap, tarief: s.hoog };
      if (subtotaal < s.drempel) return { grens: s.drempel, tarief: 0 };
      return null;
    }

    /* "Nog €64,10" leest als geld dat je kwijt bent; een aantal leest als iets
       dat je erbij krijgt. Het aantal volgt uit de gemiddelde stukprijs van wat
       er al ligt — bij dure flessen zijn dat er weinig, bij goedkope meer.
       Loopt dat aantal te hoog op (een kurkentrekker van een paar euro), dan
       zegt het bedrag meer en vallen we daarop terug. */
    var MAX_STUKS = 6;
    function hoeveelNog(cart, rest) {
      var aantal = cart.item_count || 0;
      var subtotaal = cart.items_subtotal_price || cart.total_price || 0;
      if (aantal > 0 && subtotaal > 0) {
        var gemiddeld = subtotaal / aantal;
        if (gemiddeld > 0) {
          var nodig = Math.ceil(rest / gemiddeld);
          if (nodig >= 1 && nodig <= MAX_STUKS) {
            var alleenWijn = (cart.items || []).every(function (i) {
              return /wijn/i.test(i.product_type || '');
            });
            var woord = alleenWijn
              ? (nodig === 1 ? 'fles' : 'flessen')
              : (nodig === 1 ? 'artikel' : 'artikelen');
            return nodig + ' ' + woord;
          }
        }
      }
      return euro(rest);
    }

    function balkTekst(cart, s) {
      var subtotaal = cart.total_price || 0;
      var stap = volgendeStap(s, subtotaal);
      if (!stap) return 'Gratis bezorging — mooi zo.';
      var nog = hoeveelNog(cart, stap.grens - subtotaal);
      return stap.tarief === 0
        ? 'Nog ' + nog + ' en we bezorgen gratis.'
        : 'Nog ' + nog + ' en de verzendkosten dalen naar ' + euro(stap.tarief) + '.';
    }

    function schrijfVerzendnote(cart, s) {
      var note = document.querySelector('[data-vcb-verzendnote]');
      if (!note) return;
      if (!s.bekend) {
        note.textContent = 'Verzendkosten worden bij het afrekenen berekend.';
        return;
      }
      var tarief = tariefBij(s, cart.total_price || 0);
      note.textContent = tarief === 0
        ? 'Gratis verzending.'
        : 'Verzendkosten ' + euro(tarief) + ' — gratis vanaf ' + euro(s.drempel).replace(',00', '') + '.';
    }

    function renderCart(cart) {
      itemsEl.textContent = '';
      var leeg = !cart.items || cart.items.length === 0;
      emptyEl.hidden = !leeg;
      footEl.hidden = leeg;
      if (shipWrap) shipWrap.hidden = leeg;
      if (countEl) countEl.textContent = leeg ? '' : '(' + cart.item_count + ')';
      if (totalEl) totalEl.textContent = euro(cart.total_price);

      // toegepaste kortingen (automatische kortingen zoals 11+1 zitten in cart.js)
      var korting = cart.total_discount || 0;
      if (savingsEl) {
        savingsEl.hidden = korting <= 0;
        if (korting > 0) {
          var namen = [];
          (cart.cart_level_discount_applications || []).forEach(function (d) {
            if (d.title) namen.push(d.title);
          });
          (cart.items || []).forEach(function (it) {
            (it.discounts || []).forEach(function (d) {
              if (d.title && namen.indexOf(d.title) === -1) namen.push(d.title);
            });
          });
          if (savingsLabel) savingsLabel.textContent = namen.length ? namen.join(' · ') : 'Korting';
          if (savingsAmount) savingsAmount.textContent = '−' + euro(korting);
        }
      }
      if (wasEl) {
        wasEl.hidden = korting <= 0;
        if (korting > 0) wasEl.textContent = euro(cart.original_total_price || (cart.total_price + korting));
      }

      // gratis-verzendingsbalk
      var staffel = staffelVan(shipWrap);
      if (shipWrap) {
        // Zonder bekend tarief (een ander land) zegt de balk niets zinnigs.
        shipWrap.hidden = leeg || !staffel.bekend;
        if (!shipWrap.hidden) {
          var pct = Math.min(100, Math.round((cart.total_price / staffel.drempel) * 100));
          if (shipFill) shipFill.style.width = pct + '%';
          if (shipText) {
            shipText.textContent = balkTekst(cart, staffel);
            shipText.classList.toggle('is-reached', cart.total_price >= staffel.drempel);
          }
        }
      }
      schrijfVerzendnote(cart, staffel);

      (cart.items || []).forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'vcb-ditem';

        if (item.image) {
          var img = document.createElement('img');
          img.className = 'vcb-ditem__img';
          img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
          img.alt = '';
          img.loading = 'lazy';
          row.appendChild(img);
        }

        var body = document.createElement('div');
        body.className = 'vcb-ditem__body';

        var title = document.createElement('a');
        title.className = 'vcb-ditem__title';
        title.href = item.url;
        title.textContent = item.product_title;
        body.appendChild(title);

        if (item.variant_title && item.variant_title !== 'Default Title') {
          var vt = document.createElement('span');
          vt.className = 'vcb-ditem__variant';
          vt.textContent = item.variant_title;
          body.appendChild(vt);
        }

        var ctrl = document.createElement('div');
        ctrl.className = 'vcb-ditem__ctrl';

        var qty = document.createElement('div');
        qty.className = 'vcb-ditem__qty';
        [['-', -1], ['+', 1]].forEach(function (pair, i) {
          if (i === 1) {
            var val = document.createElement('span');
            val.textContent = item.quantity;
            qty.appendChild(val);
          }
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = pair[0];
          b.setAttribute('aria-label', pair[1] > 0 ? 'Meer' : 'Minder');
          b.addEventListener('click', function () { changeLine(item.key, item.quantity + pair[1]); });
          if (i === 0) qty.appendChild(b); else qty.appendChild(b);
        });
        ctrl.appendChild(qty);

        var price = document.createElement('span');
        price.className = 'vcb-ditem__price';
        if (item.original_line_price && item.original_line_price > item.final_line_price) {
          var was = document.createElement('s');
          was.className = 'vcb-ditem__was';
          was.textContent = euro(item.original_line_price);
          price.appendChild(was);
        }
        // "€0,00" laat mensen twijfelen of ze toch betalen; "Gratis" niet.
        if (item.final_line_price === 0) {
          var gratis = document.createElement('span');
          gratis.className = 'vcb-ditem__gratis';
          gratis.textContent = 'Gratis';
          price.appendChild(gratis);
        } else {
          price.appendChild(document.createTextNode(euro(item.final_line_price)));
        }
        ctrl.appendChild(price);
        body.appendChild(ctrl);

        // toegepaste regelkorting benoemen, bijv. "11+1 gratis".
        // Shopify verdeelt een koop-X-krijg-Y-korting over alle regels: die met
        // bedrag 0 slaan we over, anders staan er "−€0,00"-labels in de mand.
        (item.discounts || []).forEach(function (d) {
          if (!d.amount) return;
          var tag = document.createElement('span');
          tag.className = 'vcb-ditem__discount';
          tag.textContent = d.title + ' −' + euro(d.amount);
          body.appendChild(tag);
        });

        var del = document.createElement('button');
        del.type = 'button';
        del.className = 'vcb-ditem__remove';
        del.textContent = 'Verwijderen';
        del.addEventListener('click', function () { changeLine(item.key, 0); });
        body.appendChild(del);

        row.appendChild(body);
        itemsEl.appendChild(row);
      });
    }

    function refresh(open) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          document.querySelectorAll('[data-vcb-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          if (open) openDrawer();
          return cart;
        });
    }

    function changeLine(key, quantity) {
      drawer.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          document.querySelectorAll('[data-vcb-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        })
        .finally(function () { drawer.classList.remove('is-busy'); });
    }

    /* kortingscode: /discount/CODE zet de code op de sessie, daarna cart opnieuw ophalen.
       Automatische kortingen zijn meteen zichtbaar; een code die alleen in de checkout
       telt, bevestigen we met tekst. */
    var dToggle = drawer.querySelector('[data-vcb-discount-toggle]');
    var dRow = drawer.querySelector('[data-vcb-discount-row]');
    var dInput = drawer.querySelector('[data-vcb-discount-input]');
    var dApply = drawer.querySelector('[data-vcb-discount-apply]');
    var dMsg = drawer.querySelector('[data-vcb-discount-msg]');

    if (dToggle && dRow) {
      dToggle.addEventListener('click', function () {
        dRow.hidden = !dRow.hidden;
        dToggle.classList.toggle('is-open', !dRow.hidden);
        if (!dRow.hidden && dInput) dInput.focus();
      });
    }

    function toonMsg(tekst, ok) {
      if (!dMsg) return;
      dMsg.hidden = false;
      dMsg.textContent = tekst;
      dMsg.classList.toggle('is-ok', !!ok);
      dMsg.classList.toggle('is-error', !ok);
    }

    function pasCodeToe() {
      if (!dInput) return;
      var code = dInput.value.trim();
      if (!code) return;
      drawer.classList.add('is-busy');
      var voor = 0;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          voor = c.total_discount || 0;
          return fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
        })
        .then(function () { return refresh(false); })
        .then(function (cart) {
          if ((cart.total_discount || 0) > voor) {
            toonMsg('Code "' + code + '" toegepast.', true);
          } else {
            toonMsg('Code "' + code + '" is genoteerd — je ziet de korting bij het afrekenen. Klopt dat niet? Controleer de code.', true);
          }
          dInput.value = '';
        })
        .catch(function () { toonMsg('Deze code kon niet worden toegepast.', false); })
        .finally(function () { drawer.classList.remove('is-busy'); });
    }

    if (dApply) dApply.addEventListener('click', pasCodeToe);
    if (dInput) {
      dInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); pasCodeToe(); }
      });
    }

    // openen na toevoegen
    document.addEventListener('vcb:cart:added', function () { refresh(true); });

    // cart-icoon opent de drawer i.p.v. navigeren
    document.addEventListener('click', function (e) {
      var link = e.target instanceof Element && e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
      if (link && !link.hasAttribute('data-vcb-no-drawer')) {
        e.preventDefault();
        refresh(true);
      }
      if (e.target instanceof Element && e.target.closest('[data-vcb-drawer-close]')) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---------- Keuzehulp ----------
     Drie stappen (gelegenheid → kleur → budget) die uitkomen op concrete
     wijnen. Er wordt gescoord in plaats van hard gefilterd: gelegenheid weegt
     het zwaarst, daarna kleur, daarna budget. Zo is er altijd een advies. */
  (function () {
    var hulp = document.querySelector('[data-vcb-keuzehulp]');
    if (!hulp) return;

    var bouwer   = document.querySelector('[data-vcb-bouwer]');
    var uitkomst = hulp.querySelector('[data-vcb-keuzehulp-uitkomst]');
    var tekst    = hulp.querySelector('[data-vcb-keuzehulp-tekst]');
    var stappen  = hulp.getAttribute('data-stappen') === '1';
    var advies   = hulp.querySelector('[data-vcb-advies]');
    var grid     = hulp.querySelector('[data-vcb-advies-grid]');
    var samenvat = hulp.querySelector('[data-vcb-samenvatting]');

    var wijnen = [];
    var databron = hulp.querySelector('[data-vcb-wijnen]');
    if (databron) { try { wijnen = JSON.parse(databron.textContent); } catch (e) { wijnen = []; } }

    var keuze = { woorden: [], naam: '', kleur: '', kleurNaam: '', min: null, max: null, budgetNaam: '', smaak: '', smaakNaam: '' };

    function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

    var terugKnop = hulp.querySelector('[data-vcb-terug]');
    var voortgang = hulp.querySelector('[data-vcb-voortgang]');
    var huidigeStap = 1;

    function toonStap(n) {
      huidigeStap = n;
      hulp.querySelectorAll('[data-vcb-stap]').forEach(function (s) {
        var nr = parseInt(s.getAttribute('data-vcb-stap'), 10);
        s.hidden = nr > n;                       // op desktop blijven eerdere stappen staan
        s.classList.toggle('is-actief', nr === n); // op mobiel telt alleen de actieve
      });
      if (terugKnop) terugKnop.hidden = n <= 1;
      if (voortgang) {
        var bolletjes = voortgang.children;
        for (var i = 0; i < bolletjes.length; i++) {
          bolletjes[i].classList.toggle('is-gedaan', i < n);
        }
      }
      // Op een telefoon staat de volgende vraag anders onder de vouw.
      if (window.matchMedia('(max-width: 47.99rem)').matches && n > 1) {
        var kop = hulp.querySelector('.vcb-keuzehulp__voortgang') || hulp;
        var y = kop.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    if (terugKnop) {
      terugKnop.addEventListener('click', function () {
        if (huidigeStap > 1) toonStap(huidigeStap - 1);
      });
    }

    function reset() {
      keuze = { woorden: [], naam: '', kleur: '', kleurNaam: '', min: null, max: null, budgetNaam: '', smaak: '', smaakNaam: '' };
      hulp.querySelectorAll('.is-actief').forEach(function (e) { e.classList.remove('is-actief'); });
      if (advies) advies.hidden = true;
      if (uitkomst) uitkomst.hidden = true;
      if (stappen) toonStap(1);
      if (bouwer) bouwer.querySelectorAll('[data-vcb-fles]').forEach(function (k) { k.hidden = false; });
    }

    // Smaakprofielen op basis van de waarden die per wijn zijn vastgelegd.
    // Drempels liggen bewust ruim: het gaat om een richting, niet om een norm.
    function smaakPast(w, profiel) {
      var zuur = Number(w.zuur), body = Number(w.body),
          zoet = Number(w.zoet), min = Number(w.mineraal);
      if (profiel === 'fris')    return (zuur >= 55) || (min >= 60);
      if (profiel === 'vol')     return (body >= 55);
      if (profiel === 'zacht')   return (zoet >= 25) || (zuur <= 45 && body <= 50);
      if (profiel === 'mineraal')return (min >= 65);
      return true;
    }

    var melding = hulp.querySelector('[data-vcb-melding]');

    /* de eigenlijke adviesmotor */
    function adviseer() {
      if (!wijnen.length || !grid) return;

      // Kleur en budget zijn keuzes van de bezoeker, geen suggesties: wie "wit"
      // aanklikt hoort geen rode wijn te zien, ook niet als die goed bij het
      // gerecht past. Daarom filteren we daar hard op en laten we alleen het
      // gerecht en de smaak de volgorde bepalen.
      var pool = wijnen.filter(function (w) {
        if (keuze.kleur && w.type !== keuze.kleur) return false;
        if (keuze.min !== null && (w.prijs < keuze.min || w.prijs > keuze.max)) return false;
        return true;
      });

      var losgelaten = '';
      if (!pool.length && keuze.min !== null) {
        // Niets binnen het budget: liever de kleur respecteren en dat eerlijk
        // melden dan zwijgend een fles buiten de vraag tonen.
        pool = wijnen.filter(function (w) { return !keuze.kleur || w.type === keuze.kleur; });
        losgelaten = 'budget';
      }
      if (!pool.length) { pool = wijnen.slice(); losgelaten = 'alles'; }

      var gescoord = pool.map(function (w) {
        var score = 0;
        var spijs = (w.spijs || []).map(function (s) { return String(s).toLowerCase(); }).join('|');
        if (keuze.woorden.length && keuze.woorden.some(function (t) { return spijs.indexOf(t) !== -1; })) score += 3;
        if (keuze.smaak && smaakPast(w, keuze.smaak)) score += 2;
        return { w: w, score: score };
      });

      gescoord.sort(function (a, b) { return b.score - a.score || a.w.prijs - b.w.prijs; });

      var hoogste = gescoord.length ? gescoord[0].score : 0;
      var aantal = parseInt(hulp.getAttribute('data-aantal'), 10) || 3;
      var top = gescoord.slice(0, aantal);

      if (melding) {
        if (losgelaten === 'budget') {
          melding.textContent = 'Binnen dit budget hebben we geen ' + (keuze.kleurNaam || 'passende') + ' wijn. Dit komt er het dichtst bij.';
          melding.hidden = false;
        } else if (losgelaten === 'alles') {
          melding.textContent = 'Geen exacte match — dit zijn onze aanraders.';
          melding.hidden = false;
        } else { melding.hidden = true; }
      }

      grid.textContent = '';
      top.forEach(function (g, i) {
        var w = g.w;
        var kaart = document.createElement('div');
        kaart.className = 'vcb-advieskaart' + (i === 0 && g.score === hoogste && hoogste >= 3 ? ' is-beste' : '');

        if (i === 0 && g.score === hoogste && hoogste >= 3) {
          var vlag = document.createElement('span');
          vlag.className = 'vcb-advieskaart__vlag';
          vlag.textContent = 'Beste match';
          kaart.appendChild(vlag);
        }

        var link = document.createElement('a');
        link.className = 'vcb-advieskaart__media';
        link.href = w.url;
        if (w.beeld) {
          var img = document.createElement('img');
          img.src = w.beeld; img.alt = w.titel; img.loading = 'lazy';
          link.appendChild(img);
        }
        kaart.appendChild(link);

        var body = document.createElement('div');
        body.className = 'vcb-advieskaart__body';

        var naam = document.createElement('a');
        naam.className = 'vcb-advieskaart__naam';
        naam.href = w.url;
        naam.textContent = w.titel;
        body.appendChild(naam);

        if (w.smaak) {
          var sm = document.createElement('p');
          sm.className = 'vcb-advieskaart__smaak';
          sm.textContent = w.smaak;
          body.appendChild(sm);
        }
        if (w.druif) {
          var dr = document.createElement('p');
          dr.className = 'vcb-advieskaart__druif';
          dr.textContent = w.druif;
          body.appendChild(dr);
        }

        // waarom dit advies
        var redenen = [];
        var spijs2 = (w.spijs || []).map(function (s) { return String(s).toLowerCase(); }).join('|');
        if (keuze.woorden.length && keuze.woorden.some(function (t) { return spijs2.indexOf(t) !== -1; })) redenen.push('past bij ' + keuze.naam.toLowerCase());
        if (keuze.kleur && w.type === keuze.kleur) redenen.push(keuze.kleurNaam.toLowerCase());
        if (keuze.min !== null && w.prijs >= keuze.min && w.prijs <= keuze.max) redenen.push('binnen je budget');
        if (redenen.length) {
          var wa = document.createElement('p');
          wa.className = 'vcb-advieskaart__waarom';
          wa.textContent = '✓ ' + redenen.join(' · ');
          body.appendChild(wa);
        }

        var prijs = document.createElement('p');
        prijs.className = 'vcb-advieskaart__prijs';
        prijs.textContent = w.prijsTekst || euro(w.prijs);
        body.appendChild(prijs);
        kaart.appendChild(body);

        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'vcb-btn vcb-btn--burgundy vcb-advieskaart__knop';
        knop.textContent = 'In winkelmand';
        knop.addEventListener('click', function () {
          knop.disabled = true; knop.textContent = 'Bezig…';
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: w.id, quantity: 1 }] })
          })
            .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
            .then(function () {
              knop.textContent = '✓ Toegevoegd';
              document.dispatchEvent(new CustomEvent('vcb:cart:added'));
              setTimeout(function () { knop.textContent = 'In winkelmand'; knop.disabled = false; }, 1800);
            })
            .catch(function () { knop.textContent = 'Niet gelukt'; knop.disabled = false; });
        });
        kaart.appendChild(knop);
        grid.appendChild(kaart);
      });

      var delen = [keuze.naam];
      if (keuze.kleurNaam) delen.push(keuze.kleurNaam.toLowerCase());
      if (keuze.smaakNaam) delen.push(keuze.smaakNaam.toLowerCase());
      if (keuze.budgetNaam) delen.push(keuze.budgetNaam.toLowerCase());
      samenvat.textContent = 'Voor ' + delen.join(', ') + ' raden we deze aan:';

      advies.hidden = false;
      var y = advies.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    /* stap 1 filtert ook de samensteller, als die op deze pagina staat */
    function filterBouwer() {
      if (!bouwer) return;
      var raak = 0;
      bouwer.querySelectorAll('[data-vcb-fles]').forEach(function (k) {
        var spijs = k.getAttribute('data-spijs') || '';
        var past = !keuze.woorden.length || keuze.woorden.some(function (t) { return spijs.indexOf(t) !== -1; });
        k.hidden = !past;
        if (past) raak++;
      });
      bouwer.querySelectorAll('[data-vcb-filter]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-vcb-filter') === 'alle');
      });
      if (uitkomst && tekst) {
        uitkomst.hidden = false;
        tekst.textContent = raak + (raak === 1 ? ' wijn past' : ' wijnen passen') +
          ' bij ' + keuze.naam.toLowerCase() + '. Stel hieronder je doos samen.';
      }
    }

    function markeer(knop, groep) {
      hulp.querySelectorAll(groep).forEach(function (b) { b.classList.toggle('is-actief', b === knop); });
    }

    hulp.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;

      if (e.target.closest('[data-vcb-keuzehulp-reset]') || e.target.closest('[data-vcb-opnieuw]')) { reset(); return; }

      var tegel = e.target.closest('[data-vcb-gelegenheid]');
      if (tegel) {
        // één stap én geen samensteller? Dan doorsturen met de keuze in de URL.
        if (!stappen && !bouwer) {
          var doel = hulp.getAttribute('data-doel');
          if (doel) {
            var scheiding = doel.indexOf('?') === -1 ? '?' : '&';
            window.location.href = doel + scheiding + 'gelegenheid=' + encodeURIComponent(tegel.getAttribute('data-vcb-slug') || '');
          }
          return;
        }
        keuze.woorden = (tegel.getAttribute('data-vcb-gelegenheid') || '').split(',')
          .map(function (w) { return w.trim(); }).filter(Boolean);
        keuze.naam = tegel.getAttribute('data-vcb-naam') || '';
        markeer(tegel, '[data-vcb-gelegenheid]');
        filterBouwer();
        if (stappen) toonStap(2);
        else if (bouwer) {
          var doelEl = bouwer.querySelector('.vcb-bouwer__grid') || bouwer;
          window.scrollTo({ top: doelEl.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
        }
        return;
      }

      var kleurKnop = e.target.closest('[data-vcb-kleur]');
      if (kleurKnop) {
        keuze.kleur = kleurKnop.getAttribute('data-vcb-kleur') || '';
        keuze.kleurNaam = keuze.kleur ? kleurKnop.textContent.trim() : '';
        markeer(kleurKnop, '[data-vcb-kleur]');
        toonStap(3);
        return;
      }

      var smaakKnop = e.target.closest('[data-vcb-smaak]');
      if (smaakKnop) {
        keuze.smaak = smaakKnop.getAttribute('data-vcb-smaak') || '';
        keuze.smaakNaam = keuze.smaak ? smaakKnop.textContent.trim() : '';
        markeer(smaakKnop, '[data-vcb-smaak]');
        toonStap(4);
        return;
      }

      var budgetKnop = e.target.closest('[data-vcb-min]');
      if (budgetKnop) {
        var min = budgetKnop.getAttribute('data-vcb-min');
        keuze.min = min === '' ? null : parseInt(min, 10);
        keuze.max = min === '' ? null : parseInt(budgetKnop.getAttribute('data-vcb-max'), 10);
        keuze.budgetNaam = min === '' ? '' : budgetKnop.textContent.trim();
        markeer(budgetKnop, '[data-vcb-min]');
        adviseer();
      }
    });

    // binnenkomen met ?gelegenheid=... → die keuze meteen toepassen
    (function () {
      var slug = new URLSearchParams(window.location.search).get('gelegenheid');
      if (!slug) return;
      var t = hulp.querySelector('[data-vcb-slug="' + slug.replace(/"/g, '') + '"]');
      if (t) setTimeout(function () { t.click(); }, 60);
    })();
  })();

  /* ---------- Doos samenstellen ----------
     Klant kiest zelf flessen; wij tellen mee, rekenen de actie vóór en leggen
     alles in één keer in de mand. De korting zelf komt uit Shopify. */
  (function () {
    var wrap = document.querySelector('[data-vcb-bouwer]');
    if (!wrap) return;

    var DOOS   = parseInt(wrap.getAttribute('data-doos'), 10) || 12;
    var GRATIS = parseInt(wrap.getAttribute('data-gratis'), 10) || 0;
    var balk   = wrap.querySelector('[data-vcb-bouwer-balk]');
    var teller = wrap.querySelector('[data-vcb-teller]');
    var hint   = wrap.querySelector('[data-vcb-hint]');
    var voortg = wrap.querySelector('[data-vcb-voortgang]');
    var wasEl  = wrap.querySelector('[data-vcb-was]');
    var nuEl   = wrap.querySelector('[data-vcb-nu]');
    var addBtn = wrap.querySelector('[data-vcb-bouwer-add]');

    function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

    function keuzes() {
      var uit = [];
      wrap.querySelectorAll('[data-vcb-fles]').forEach(function (k) {
        var n = parseInt(k.querySelector('[data-vcb-aantal]').textContent, 10) || 0;
        if (n > 0) uit.push({ id: k.getAttribute('data-id'), prijs: parseInt(k.getAttribute('data-prijs'), 10), aantal: n });
      });
      return uit;
    }

    function ververs() {
      var gekozen = keuzes();
      var totaalAantal = gekozen.reduce(function (s, x) { return s + x.aantal; }, 0);

      // prijzen uitgeklapt en oplopend: de goedkoopste zijn gratis
      var prijzen = [];
      gekozen.forEach(function (x) { for (var i = 0; i < x.aantal; i++) prijzen.push(x.prijs); });
      prijzen.sort(function (a, b) { return a - b; });

      var bruto = prijzen.reduce(function (s, p) { return s + p; }, 0);
      var dozen = Math.floor(totaalAantal / DOOS);
      var gratisStuks = dozen * GRATIS;
      var korting = 0;
      for (var i = 0; i < gratisStuks && i < prijzen.length; i++) korting += prijzen[i];

      balk.hidden = totaalAantal === 0;
      teller.textContent = totaalAantal + ' van ' + DOOS;
      voortg.style.width = Math.min(100, (totaalAantal % DOOS === 0 && totaalAantal > 0 ? 100 : (totaalAantal % DOOS) / DOOS * 100)) + '%';

      var rest = (DOOS - (totaalAantal % DOOS)) % DOOS;
      if (totaalAantal === 0) {
        hint.textContent = '';
      } else if (rest === 0) {
        hint.textContent = dozen === 1 ? 'Compleet — de goedkoopste fles is gratis'
                                       : 'Compleet — ' + gratisStuks + ' flessen gratis';
        hint.className = 'vcb-bouwer__hint is-goed';
      } else {
        hint.textContent = 'Nog ' + rest + (rest === 1 ? ' fles' : ' flessen') + ' voor een volle doos';
        hint.className = 'vcb-bouwer__hint';
      }

      if (korting > 0) { wasEl.hidden = false; wasEl.textContent = euro(bruto); }
      else wasEl.hidden = true;
      nuEl.textContent = euro(bruto - korting);

      // toevoegen mag altijd, maar we sturen bij als de doos nog niet vol is
      addBtn.disabled = totaalAantal === 0;
      addBtn.classList.toggle('vcb-btn--outline', rest !== 0 && totaalAantal > 0);
    }

    wrap.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var kaart = t.closest('[data-vcb-fles]');
      if (kaart) {
        var veld = kaart.querySelector('[data-vcb-aantal]');
        var nu = parseInt(veld.textContent, 10) || 0;
        var max = parseInt(kaart.getAttribute('data-max'), 10) || 99;
        if (t.hasAttribute('data-vcb-plus') && nu < max) veld.textContent = nu + 1;
        if (t.hasAttribute('data-vcb-min') && nu > 0) veld.textContent = nu - 1;
        kaart.classList.toggle('is-gekozen', (parseInt(veld.textContent, 10) || 0) > 0);
        ververs();
        return;
      }

      var filter = t.closest('[data-vcb-filter]');
      if (filter) {
        var soort = filter.getAttribute('data-vcb-filter');
        wrap.querySelectorAll('[data-vcb-filter]').forEach(function (b) { b.classList.toggle('is-active', b === filter); });
        wrap.querySelectorAll('[data-vcb-fles]').forEach(function (k) {
          k.hidden = soort !== 'alle' && k.getAttribute('data-type') !== soort;
        });
      }
    });

    addBtn.addEventListener('click', function () {
      var gekozen = keuzes();
      if (!gekozen.length) return;
      addBtn.disabled = true;
      var origineel = addBtn.innerHTML;
      addBtn.textContent = 'Bezig…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: gekozen.map(function (x) { return { id: x.id, quantity: x.aantal }; }) })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Toevoegen mislukt'); });
          return r.json();
        })
        .then(function () {
          // selectie leegmaken en de drawer openen
          wrap.querySelectorAll('[data-vcb-aantal]').forEach(function (v) { v.textContent = '0'; });
          wrap.querySelectorAll('[data-vcb-fles]').forEach(function (k) { k.classList.remove('is-gekozen'); });
          addBtn.innerHTML = origineel;
          ververs();
          document.dispatchEvent(new CustomEvent('vcb:cart:added'));
        })
        .catch(function (err) {
          addBtn.innerHTML = origineel;
          addBtn.disabled = false;
          hint.textContent = err.message;
          hint.className = 'vcb-bouwer__hint is-fout';
        });
    });

    ververs();
  })();

  /* ---------- PDP: hele doos in één klik ---------- */
  document.addEventListener('click', function (e) {
    var box = e.target instanceof Element && e.target.closest('[data-vcb-box]');
    if (!box) return;
    var qty = parseInt(box.getAttribute('data-vcb-box'), 10) || 6;
    var form = box.closest('form[data-vcb-atc]');
    if (!form) return;
    var input = form.querySelector('[data-vcb-qty-input]');
    if (input) input.value = qty;
    document.querySelectorAll('[data-vcb-qty-input]').forEach(function (i) { i.value = qty; });
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });

  /* ---------- PDP: variantpicker ---------- */
  var vWrap = document.querySelector('[data-vcb-variants]');
  var vData = document.querySelector('[data-vcb-variant-data]');
  if (vWrap && vData) {
    var variants = [];
    try { variants = JSON.parse(vData.textContent); } catch (e) {}

    function money(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
    function selectedOptions() {
      return Array.prototype.map.call(
        vWrap.querySelectorAll('.vcb-variant'),
        function (row) {
          var checked = row.querySelector('.vcb-variant__radio:checked');
          return checked ? checked.value : null;
        }
      );
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return !o || v.options[i] === o; });
      })[0];
    }
    // Shopify noemt een variant met doorverkopen "available", ook bij een leeg
    // schap. De echte staat rekent de sectie per variant uit; hier lezen we die
    // terug zodat de levertijd niet omslaat in "op voorraad" bij een klik.
    var staten = {};
    var staatEl = document.querySelector('[data-vcb-variant-staat]');
    if (staatEl) { try { staten = JSON.parse(staatEl.textContent); } catch (e) {} }

    var koop = document.querySelector('[data-vcb-koop]');
    var preRegel = document.querySelector('[data-vcb-stock-pre]');
    var uitRegel = document.querySelector('[data-vcb-stock-uit]');
    var klokBlok = document.querySelector('[data-vcb-klok]');
    var bericht = document.querySelector('[data-vcb-bericht]');

    function toonStaat(v) {
      var staat = staten[String(v.id)] || (v.available ? 'op' : 'uit');
      var isPre = staat === 'datum' || staat === 'termijn';

      if (preRegel) {
        preRegel.hidden = !isPre;
        var kop = preRegel.querySelector('[data-vcb-stock-regel]');
        if (kop && koop) {
          kop.textContent = staat === 'datum'
            ? (koop.getAttribute('data-tekst-datum') || kop.textContent)
            : (koop.getAttribute('data-tekst-termijn') || kop.textContent);
        }
      }

      if (uitRegel) {
        uitRegel.hidden = isPre || staat === 'op';
        var tekst = uitRegel.querySelector('[data-vcb-uit-regel]');
        if (tekst) tekst.textContent = staat === 'weg' ? 'Niet meer leverbaar' : 'Tijdelijk uitverkocht';
      }

      if (klokBlok) klokBlok.classList.toggle('vcb-klok--uit', staat !== 'op');
      if (bericht) bericht.hidden = !(staat === 'uit' || staat === 'weg');
    }

    function updateVariant() {
      var opts = selectedOptions();
      var v = findVariant(opts);

      // labels naast de optienaam bijwerken
      vWrap.querySelectorAll('[data-vcb-option-value]').forEach(function (el, i) {
        if (opts[i]) el.textContent = opts[i];
      });

      if (!v) return;

      document.querySelectorAll('[data-vcb-variant-id]').forEach(function (input) { input.value = v.id; });
      document.querySelectorAll('[data-vcb-price]').forEach(function (el) { el.textContent = money(v.price); });

      var btn = document.querySelector('[data-vcb-add]');
      var btnText = document.querySelector('[data-vcb-add-text]');
      if (btn) {
        btn.disabled = !v.available;
        if (btnText) btnText.textContent = v.available ? (btn.getAttribute('data-label') || btnText.getAttribute('data-original') || btnText.textContent) : 'Uitverkocht';
      }

      document.querySelectorAll('[data-vcb-volume]').forEach(function (el) {
        if (v.title && v.title !== 'Default Title') el.textContent = v.title;
      });

      toonStaat(v);

      // hoofdafbeelding wisselen als de variant een eigen foto heeft
      if (v.featured_image && v.featured_image.src) {
        var main = document.querySelector('[data-vcb-mainimg]');
        if (main) { main.src = v.featured_image.src; main.srcset = ''; }
      }

      // URL bijwerken zonder herladen
      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    // originele knoptekst onthouden
    var bt = document.querySelector('[data-vcb-add-text]');
    if (bt && !bt.getAttribute('data-original')) bt.setAttribute('data-original', bt.textContent.trim());

    vWrap.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('vcb-variant__radio')) updateVariant();
    });
  }

  /* ---------- PDP: informatietabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target instanceof Element && e.target.closest('[data-vcb-tab]');
    if (!tab) return;
    var wrap = tab.closest('[data-vcb-tabs]');
    if (!wrap) return;
    var id = tab.getAttribute('data-vcb-tab');
    wrap.querySelectorAll('[data-vcb-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', String(on));
    });
    wrap.querySelectorAll('[data-vcb-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-vcb-panel') !== id;
    });
  });

  /* ---------- PDP: sticky buy bar ----------
     Verschijnt zodra de echte add-to-cart-knop uit beeld is. Dat werkt op elk
     schermformaat; een vaste scrollafstand kwam op mobiel te laat of te vroeg. */
  var sticky = document.querySelector('.vcb-stickybar');
  if (sticky) {
    var atc = document.querySelector('[data-vcb-atc], .vcb-pdp__form button[type="submit"], .vcb-pdp form button[type="submit"]');

    if (atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // knop zichtbaar → balk weg; knop voorbij gescrold → balk tonen
          var voorbij = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', voorbij);
        });
      }, { rootMargin: '0px 0px -80px 0px' }).observe(atc);
    } else {
      var onScroll = function () {
        sticky.classList.toggle('is-visible', window.scrollY > 720);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }
})();

/* ---------- staffelkeuze op de productpagina ---------- */
(function () {
  var blok = document.querySelector('[data-vcb-staffel]');
  if (!blok) return;
  var qtyInput = document.querySelector('[data-vcb-qty-input]');
  var opties = blok.querySelectorAll('[data-vcb-staffel-optie]');

  function kies(optie) {
    opties.forEach(function (o) { o.classList.toggle('is-actief', o === optie); });
    var radio = optie.querySelector('input');
    if (radio) radio.checked = true;
    if (qtyInput) {
      qtyInput.value = optie.getAttribute('data-qty');
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  opties.forEach(function (o) {
    o.addEventListener('click', function () { kies(o); });
    o.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); kies(o); }
    });
  });

  // Verandert iemand het aantal met de plus/min, dan mag de staffel niet
  // een keuze blijven tonen die niet meer klopt.
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var n = parseInt(qtyInput.value, 10);
      var match = null;
      opties.forEach(function (o) { if (parseInt(o.getAttribute('data-qty'), 10) === n) match = o; });
      opties.forEach(function (o) { o.classList.toggle('is-actief', o === match); });
      if (!match) {
        opties.forEach(function (o) { var r = o.querySelector('input'); if (r) r.checked = false; });
      }
    });
  }
})();

/* ---------- levertijd: aftellen naar de verzendgrens ---------- */
(function () {
  var blok = document.querySelector('[data-vcb-klok]');
  if (!blok) return;
  var grensUur = parseInt(blok.getAttribute('data-uur'), 10) || 17;
  var koel = blok.getAttribute('data-koel') === '1';
  var regel = blok.querySelector('[data-vcb-klok-regel]');
  var sub = blok.querySelector('[data-vcb-klok-sub]');
  var dagen = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function tel(n) { return n < 10 ? '0' + n : '' + n; }

  // Eerstvolgende werkdag ná een gegeven datum.
  function volgendeWerkdag(d) {
    var v = new Date(d.getTime());
    do { v.setDate(v.getDate() + 1); } while (v.getDay() === 0 || v.getDay() === 6);
    return v;
  }

  function werk() {
    var nu = new Date();
    var dag = nu.getDay();
    var isWeekend = dag === 0 || dag === 6;
    var grens = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate(), grensUur, 0, 0);

    // Buiten de bestelwindow: geen misleidende aftelling, wel een eerlijke belofte.
    if (isWeekend || nu >= grens) {
      var lever = volgendeWerkdag(nu >= grens ? nu : new Date(nu.getTime() - 86400000));
      if (isWeekend) lever = volgendeWerkdag(nu);
      regel.textContent = 'Besteld voor ' + grensUur + ':00 op werkdagen';
      sub.textContent = 'Bestel je nu, dan gaat je pakket ' + dagen[lever.getDay()] + ' de deur uit.';
      blok.hidden = false;
      return;
    }

    var over = grens - nu;
    var u = Math.floor(over / 3600000);
    var m = Math.floor((over % 3600000) / 60000);
    var s = Math.floor((over % 60000) / 1000);

    // Vrijdag vóór de grens levert maandag, niet "morgen".
    var morgen = dag === 5 ? 'maandag in huis' : 'morgen in huis';
    regel.innerHTML = 'Bestel binnen <b>' + tel(u) + ':' + tel(m) + ':' + tel(s) + '</b> → ' + morgen;
    sub.textContent = koel ? 'Vandaag verzonden, gekoeld verpakt.' : 'Vandaag verzonden.';
    blok.hidden = false;
  }

  werk();
  setInterval(werk, 1000);
})();

/* ---------- cadeau bij een volle doos ----------
   De korting in Shopify maakt het cadeau gratis, maar rekent alleen af als het
   ook daadwerkelijk in de winkelwagen ligt. Zonder dit script zou de klant zes
   flessen bestellen en zijn kurkentrekker mislopen — de belofte op de
   productpagina zou dan niet uitkomen. */
(function () {
  var bron = document.querySelector('[data-vcb-cadeau]');
  if (!bron) return;
  var cfg;
  try { cfg = JSON.parse(bron.textContent); } catch (e) { return; }
  if (!cfg.variant || !cfg.wijnen || !cfg.wijnen.length) return;

  var CADEAU = String(cfg.variant);
  var DREMPEL = cfg.drempel || 6;
  var wijn = {};
  cfg.wijnen.forEach(function (id) { wijn[String(id)] = true; });

  var bezig = false;

  function cart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function pas(c) {
    var flessen = 0, cadeauRegel = null;
    c.items.forEach(function (i) {
      var id = String(i.variant_id);
      if (id === CADEAU) { cadeauRegel = i; return; }
      if (wijn[id]) flessen += i.quantity;
    });

    var hoort = flessen >= DREMPEL;

    if (hoort && !cadeauRegel) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(CADEAU), quantity: 1, properties: { _cadeau: 'doos' } }] })
      }).then(ververs);
    }

    // Alleen weghalen wat wij zelf hebben neergelegd; een kurkentrekker die de
    // klant bewust heeft toegevoegd blijft staan.
    if (!hoort && cadeauRegel && cadeauRegel.properties && cadeauRegel.properties._cadeau) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cadeauRegel.key, quantity: 0 })
      }).then(ververs);
    }
    return Promise.resolve();
  }

  function ververs() {
    document.dispatchEvent(new CustomEvent('vcb:cart-updated'));
    if (typeof window.vcbCartRefresh === 'function') window.vcbCartRefresh();
  }

  function check() {
    if (bezig) return;
    bezig = true;
    cart().then(pas).catch(function () {}).then(function () { bezig = false; });
  }

  // Meeliften op elke winkelwagenwijziging, ongeacht welk script hem uitvoert.
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var pad = typeof url === 'string' ? url : (url && url.url) || '';
    var isCart = /\/cart\/(add|change|update|clear)/.test(pad);
    return origFetch.apply(this, arguments).then(function (res) {
      if (isCart && !bezig) setTimeout(check, 60);
      return res;
    });
  };

  check();
})();

/* ---------- vaak samen besteld ----------
   Haalt Shopify's complementaire aanbevelingen op. Levert dat niets, dan valt
   het terug op een ingestelde collectie. Blijft verborgen tot er echt iets te
   tonen is — een lege kop onder de bestelknop is erger dan geen kop. */
(function () {
  var blok = document.querySelector('[data-vcb-crosssell]');
  if (!blok) return;
  var rij = blok.querySelector('[data-vcb-crosssell-rij]');
  var pid = blok.getAttribute('data-product');
  var aantal = parseInt(blok.getAttribute('data-aantal'), 10) || 3;
  var fallback = blok.getAttribute('data-fallback');
  // Artikelen die nooit als aanbeveling mogen verschijnen (tag "geen-aanbeveling").
  var verboden = {};
  (blok.getAttribute('data-uitgesloten') || '').split(',').forEach(function (id) {
    var v = id.trim(); if (v) verboden[v] = true;
  });
  if (!pid || !rij) return;

  function geld(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

  // De twee bronnen leveren verschillende vormen: /recommendations geeft prijs in
  // centen met een available-vlag, /collections/x/products.json geeft prijs als
  // tekst in euro's en alleen per variant. Hier maken we er één vorm van.
  function normaliseer(p) {
    if (!p) return null;
    var beschikbaar = typeof p.available === 'boolean'
      ? p.available
      : (p.variants || []).some(function (v) { return v.available; });
    var prijs = typeof p.price === 'number'
      ? p.price
      : (p.variants && p.variants.length ? Math.round(parseFloat(p.variants[0].price) * 100) : null);
    var beeld = p.featured_image
      || (p.featured_media && p.featured_media.preview_image && p.featured_media.preview_image.src)
      || (p.images && p.images.length ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src) : null);
    if (prijs === null || isNaN(prijs)) return null;
    return {
      id: p.id, title: p.title,
      url: p.url || ('/products/' + p.handle),
      price: prijs, beeld: beeld, available: beschikbaar
    };
  }

  function teken(producten) {
    var lijst = (producten || []).map(normaliseer).filter(function (p) {
      return p && p.available && String(p.id) !== String(pid) && !verboden[String(p.id)];
    }).slice(0, aantal);
    if (!lijst.length) return false;

    rij.textContent = '';
    lijst.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'vcb-crosssell__item';
      a.href = p.url;

      if (p.beeld) {
        var img = document.createElement('img');
        img.src = p.beeld.indexOf('?') > -1 ? p.beeld : p.beeld + '?width=160';
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }
      var tek = document.createElement('span');
      tek.className = 'vcb-crosssell__tekst';
      var t = document.createElement('span');
      t.className = 'vcb-crosssell__naam';
      t.textContent = p.title;
      var pr = document.createElement('span');
      pr.className = 'vcb-crosssell__prijs';
      pr.textContent = geld(p.price);
      tek.appendChild(t); tek.appendChild(pr);
      a.appendChild(tek);
      rij.appendChild(a);
    });
    blok.hidden = false;
    return true;
  }

  function haal(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // Eerst wat Shopify als aanvullend kent, dan de ingestelde collectie. Pas
  // als laatste redmiddel vergelijkbare producten: die staan onderaan de pagina
  // al, en "meer van hetzelfde" naast de knop verkoopt niets extra.
  haal('/recommendations/products.json?product_id=' + pid + '&limit=' + (aantal + 2) + '&intent=complementary')
    .then(function (d) {
      if (d && d.products && d.products.length && teken(d.products)) return null;
      if (fallback) return haal('/collections/' + fallback + '/products.json?limit=' + (aantal + 4));
      return null;
    })
    .then(function (d) {
      if (d && d.products && teken(d.products)) return null;
      return haal('/recommendations/products.json?product_id=' + pid + '&limit=' + (aantal + 2) + '&intent=related');
    })
    .then(function (d) { if (d && d.products) teken(d.products); })
    .catch(function () {});
})();


/* ---------- balk bovenaan: één melding tegelijk op smalle schermen ----------
   Twee usp's onder elkaar maakten de balk twee regels hoog. Op mobiel rouleren
   we ze; op desktop blijft alles gewoon naast elkaar staan. */
(function () {
  var balk = document.querySelector('.vcb-topbar__inner');
  if (!balk) return;
  var items = [].slice.call(balk.children).filter(function (el) {
    return !el.classList.contains('vcb-topbar__dot') && el.textContent.trim();
  });
  if (items.length < 2) return;

  var mq = window.matchMedia('(max-width: 40rem)');
  var i = 0, timer = null;

  function toon(n) {
    items.forEach(function (el, k) { el.classList.toggle('is-zichtbaar', k === n); });
  }
  function start() {
    stop();
    toon(0); i = 0;
    var traag = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    timer = setInterval(function () {
      i = (i + 1) % items.length;
      toon(i);
    }, traag ? 7000 : 4000);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
    items.forEach(function (el) { el.classList.remove('is-zichtbaar'); });
  }
  function pas() { if (mq.matches) start(); else stop(); }

  pas();
  if (mq.addEventListener) mq.addEventListener('change', pas);
  else if (mq.addListener) mq.addListener(pas);

  // Niet doorrouleren wanneer het tabblad op de achtergrond staat.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { if (timer) { clearInterval(timer); timer = null; } }
    else pas();
  });
})();

/* ---------- bericht bij terugkomst ----------
   Staat alleen op productpagina's zonder leverdatum: dan valt er niets te
   bestellen en is een adres achterlaten het enige zinnige alternatief.
   Het product gaat als eigenschap mee, zodat er later per artikel een bericht
   uit te sturen is. */
(function () {
  var blok = document.querySelector('[data-vcb-bericht]');
  if (!blok) return;
  var form = blok.querySelector('[data-vcb-bericht-form]');
  var input = blok.querySelector('.vcb-bericht__input');
  var knop = blok.querySelector('[data-vcb-bericht-knop]');
  var knoptxt = blok.querySelector('[data-vcb-bericht-knoptekst]');
  var melding = blok.querySelector('[data-vcb-bericht-melding]');
  var bezig = false;

  function zeg(tekst, goed) {
    melding.textContent = tekst;
    melding.className = 'vcb-bericht__melding ' + (goed ? 'is-goed' : 'is-fout');
    melding.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (bezig) return;

    var email = (input.value || '').trim();
    if (!email || email.indexOf('@') < 1 || email.indexOf('.', email.indexOf('@')) < 0) {
      zeg('Vul een geldig e-mailadres in.', false);
      input.focus();
      return;
    }

    var lijst = (blok.getAttribute('data-list') || '').trim();
    var company = (blok.getAttribute('data-company') || '').trim();
    if (!lijst || !company) {
      zeg('Aanmelden lukt nu even niet. Probeer het later opnieuw.', false);
      if (window.console) console.warn('[bericht] lijst-id of publieke sleutel ontbreekt');
      return;
    }

    bezig = true;
    knop.disabled = true;
    var oud = knoptxt.textContent;
    knoptxt.textContent = 'Even geduld…';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Bericht bij terugkomst',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    gewenst_product: blok.getAttribute('data-product'),
                    gewenst_product_handle: blok.getAttribute('data-handle'),
                    aangemeld_op: new Date().toISOString()
                  }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: lijst } } }
        }
      })
    }).then(function (r) {
      if (r.status === 202 || r.ok) {
        form.hidden = true;
        zeg('Gelukt — je hoort van ons zodra er nieuws is.', true);
      } else {
        throw new Error('Klaviyo ' + r.status);
      }
    }).catch(function (err) {
      bezig = false;
      knop.disabled = false;
      knoptxt.textContent = oud;
      zeg('Het aanmelden lukte niet. Probeer het zo nog eens.', false);
      if (window.console) console.warn('[bericht]', err);
    });
  });
})();


/* ---------- loyaliteit via de header ----------
   De zwevende Appstle-knop is verborgen (hij lag over de afrekenknop). De knop
   in de header opent hetzelfde paneel. Staat Appstle nog niet klaar, dan volgt
   de browser gewoon de link naar de clubpagina. */
(function () {
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-vcb-club-open]');
    if (!knop) return;
    var appstle = document.getElementById('appstle-loyalty-button');
    if (!appstle) return;               // geen paneel: link naar de clubpagina volgen
    e.preventDefault();
    appstle.click();
  });
})();
